import { initializeApp } from "firebase/app";
import {initializeFirestore} from 'firebase/firestore/lite';
import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId:  process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measurementId
};


const app = initializeApp(firebaseConfig);
initializeFirestore(app, {ignoreUndefinedProperties: true});
export const db = getFirestore(app);

    async function getFirestoreDocs(colecao) {
    const col = collection(db, colecao); 
    const response = await getDocs(col);
    const ret = response.docs.map(doc => doc.data());
    return ret;
    } 

export default getFirestoreDocs;